"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyData = void 0;
const models_1 = require("../../production/models");
const enums_1 = require("../enums");
class SupplyData {
}
exports.SupplyData = SupplyData;
//# sourceMappingURL=supply-data.response.js.map